// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cWraEF5t1owlOqJWB8hu{background:var(--background-neutral-subtle);border-radius:8px;flex-direction:column;gap:4px;margin-top:24px;padding:16px 20px;display:flex}.BNiTwQZuqMzVpTSdnk3C{margin-bottom:12px}.MCjHlBF_FcDjPsLtV6wG{gap:8px;display:flex}.gUpE0I75YA48dL_mcc5U{margin-bottom:20px;margin-left:26px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sampleMessageModalMustIncludeWrap": `cWraEF5t1owlOqJWB8hu`,
	"mustIncludeTitle": `BNiTwQZuqMzVpTSdnk3C`,
	"mustIncludeLine": `MCjHlBF_FcDjPsLtV6wG`,
	"mustIncludeExampleLine": `gUpE0I75YA48dL_mcc5U`
};
export default ___CSS_LOADER_EXPORT___;
